export enum CommonPermissions {
  UploadCreate = 'upload_create',
}
